import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import * as notificationsActions from '../actions';
import * as notificationsApi from '../api';

function* updateMarkAsSeen() {
  try {
    yield call(notificationsApi.updateMarkAsSeen);
    yield put(notificationsActions.successUpdateMarkAsSeen());
  } catch (error) {
    yield put(handleServerError(error));
  }
}

export default updateMarkAsSeen;
